const slug = value => String(value||'').replace(/[^a-z0-9_]+/gi,'-').replace(/^-|-$/g,'').toLowerCase();
export function storefrontMedicine(groups,language,name) {
 if(!Array.isArray(groups))return {};
 const current=groups.find(group=>group.lang===language)?.data||[];
 const exact=current.find(row=>slug(row.genericBrand)===name);
 if(exact?.visible===true)return exact;
 let match,from;
 for(const group of groups){const row=group.data?.find(row=>slug(row.genericBrand)===name);if(row){match=row;from=group.lang;break;}}
 if(!match)return {};
 const identity=from==='en'?match.fixedMedicineId:match.medicineDetectorId;
 const localized=current.find(row=>(language==='en'?row.fixedMedicineId:row.medicineDetectorId)===identity);
 if(localized?.visible===true)return localized;
 const english=groups.find(group=>group.lang==='en')?.data.find(row=>row.fixedMedicineId===identity);
 return english?.visible===true?{...english,medicineDetectorId:english.fixedMedicineId}:{};
}
